import pngArray from "report/common/png";

const iconArr = Object.keys(pngArray).reduce((acc, e) => {
  const key = e as keyof typeof pngArray;
  acc[key] = {
    width: key.includes("Fathom") ? 9 : 12,
    height: key.includes("Fathom") ? 9 : 12,
    align: "left",
    backgroundColor: {
      image: pngArray[key]
    }
  };
  return acc;
}, {} as Record<string, any>);

export default iconArr;
